export const REPORT_TYPE = [
    { label: "Select Report Type", value: "" },
    { label: "Month End Report", value: "monthEndReport" },
    { label: "Warranties Monthly Report", value: "warrantiesMonthlyReport"},
    { label: "Contractors With Template Report", value: "TemplateCountByContractorReport"}
    // { label: "Contractor RewardsPoints", value: "contractorRewardsPoints" },
];

export const T2 = {
    type: "Report Type",
    dateRange: "Selecte Date Range",
    submit: "Generate Report",
    customerId: "Customer ID",
    select: "Select",
    fromDate: "From",
    toDate: "To",
    message: "Please select To Date",
    reportMsg: "Please select Report Type",
    dateMsg: "Please select Date Range",
    maxDays: 40,
};

export const SUCCESS_MSG = (type) => {
    return `Your request for ${type} is submitted. You will receive the report in email`;
};
export const ERROR_MSG = "There is some techincal error. Please try again";
